var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMais(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "468100CA-13A2-4271-8B2E-C9C3CCE6CFA8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Pesquisa",
    transform: "translate(-861.000000, -5241.000000)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(771.000000, 5229.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.071068,30.0710678 C111.960155,26.1819805 111.960155,19.8180195 108.071068,15.9289322 C104.181981,12.0398449 97.8180195,12.0398449 93.9289322,15.9289322 C90.0398449,19.8180195 90.0398449,26.1819805 93.9289322,30.0710678 C97.8180195,33.9601551 104.181981,33.9601551 108.071068,30.0710678 Z M96.9977326,23.0000189 L105.002181,23.0000189 M100.999957,27.0022432 L100.999957,18.9977946",
    id: "mais"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMais);
export default __webpack_public_path__ + "static/media/mais.4836d7c0f7f58f84f55aa1048a89b4ef.svg";
export { ForwardRef as ReactComponent };